import type { ExcIncreaseV1WireKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const INCREASE_WIRE_BASE_PATH = getResolvedPath('/clearing/vendor/increase/wire');

export const getIncreaseWirePath: EntityPathBuilder<ExcIncreaseV1WireKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return INCREASE_WIRE_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.wireId) {
        return undefined;
      }

      return getResolvedPath(`${INCREASE_WIRE_BASE_PATH}/$wireId`, context.keys);
    }
  }
};

export function getIncreaseWireDetailPath(wireId: string | undefined) {
  if (!wireId) {
    return undefined;
  }

  return getIncreaseWirePath({ kind: 'detail', keys: { wireId } });
}
